export class Court
{
  id:string;
  code: string;
  name: string;
  eFilingStateID: string;
  eFilingUrl: string;
  isActive:boolean;
  allowInitialFiling:boolean;
  allowSubsequentFiling:boolean;
}
